export default class Menu {
    constructor() {
        this.menu = document.querySelector('.header__menu');

        if (!this.menu) return false;

        this.links = this.menu.querySelector('.header__menu a');

        this.links = this.menu.querySelectorAll('.header__menu a');
        this.burger = document.querySelector('.header__burger');
        this.isMobileMenuActive = false;

        this.events();
        this.init();
    }

    init() {
    }

    events() {
        if (window.matchMedia("(max-width: 768px)").matches) {
            this.links.forEach(link => link.addEventListener('click', this.linksHandler.bind(this)));
            this.burger.addEventListener('click', this.burgerHandler.bind(this))
        }

        window.addEventListener('resize', this.removeDisableScroll.bind(this))
    }

    linksHandler(e) {
        const menuList = e.target.closest('.main-menu__list');
        const mainMenu = document.querySelector('.main-menu');
        const parent = e.target.closest('.dropdown-menu');
        const spinner = document.querySelector('.main-menu__spinner');
        if (spinner) spinner.remove();
        if (parent) {
            const spinner = `<img class="main-menu__spinner" src="${HT.imagesUri}/menu-spinner.svg">`
            mainMenu.insertAdjacentHTML('afterBegin', spinner)
        }
    }

    burgerHandler() {
        this.isMobileMenuActive = !this.isMobileMenuActive;
        if (this.isMobileMenuActive) {
            document.body.classList.add('disable-scroll')
        } else {
            document.body.classList.remove('disable-scroll');
            const spinner = document.querySelector('.main-menu__spinner');
            if (spinner) spinner.remove();
        }

    }

    removeDisableScroll() {
        if (window.matchMedia("(max-width: 768px)").matches && this.isMobileMenuActive) {
            document.body.classList.add('disable-scroll')
        } else {
            document.body.classList.remove('disable-scroll')
        }
    }
}
